import * as ActionTypes from '../constants/constant_action_types';

export function setScreenLocation(path) {
  return {
    type: ActionTypes.SET_CURRENT_PATH,
    path
  };
}

export function showPromptModal(header, body, confirmOnly = true) {
  return {
    type: ActionTypes.COMMON_PROMPT_MODAL_SHOW,
    payload: { header, body, confirmOnly },
  };
}

export function hidePromptModal() {
  return { type: ActionTypes.COMMON_PROMPT_MODAL_HIDE };
}

export function signalPromptModal(signal) {
  return {
    type: ActionTypes.COMMON_PROMPT_MODAL_SIGNAL,
    signal,
  };
}
